<template>
  <!--  <el-container class="footer">-->
  <!--    <el-row :style="{paddingTop:'1rem'}">-->
  <!--      <el-col :span="14" :style="{padding:'0 1rem'}">-->
  <!--        <el-col :span="6" :style="{padding:'1rem'}">-->
  <!--          <img class="img-responsive" alt="" src="https://pic.sharkpark.cn/shark/footer_logo.png"/>-->
  <!--        </el-col>-->
  <!--        <el-col :span="18">-->
  <!--          <p>© 2012-2019 北京鲨鱼公园教育科技有限公司 京ICP备14029296号-1</p>-->
  <!--          <p>北京鲨鱼公园教育科技有限公司成立于2014年5月，目前是中国青少儿科技教育品牌，专业针对3-15岁儿童，提供动手科学产品及趣味性的课程学习。坚持自产自研，课程覆盖科学、编程、美术、礼仪、数理、天文等领域。</p>-->
  <!--          <p>地址：北京市朝阳区建外SOHO东区</p>-->
  <!--        </el-col>-->
  <!--      </el-col>-->
  <!--      <el-col :span="10">-->
  <!--        <img class="img-responsive" style="float: right" alt="" src="https://pic.sharkpark.cn/shark/footer_tel.png"/>-->
  <!--      </el-col>-->
  <!--    </el-row>-->
  <!--  </el-container>-->
  <div class="footer123">
    <!-- <img src="../assets/img/index/footer.jpg" alt=""> -->
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>
<style>
  /*@import "../assets/scss/style.scss";*/
  /*@import "../assets/scss/footer.scss";*/

  .footer123 {
    /*margin:0 auto;*/
  /*  width: 100%;
    text-align:center;*/
      /*width: 100%;*/
      height: 213px;
      background: url('../assets/img/index/footer.jpg') no-repeat center;
      /*background-size: cover;*/
      background-color: #434343;
  }
</style>
